import React, { useState, useEffect, useContext } from "react";
import styled from "styled-components";
import { useQuery, useMutation, useQueryClient } from "react-query";
import { Modal, Button, SelectPicker } from "rsuite";
import apiClient from "../../libraries/ApiClient";
import { ModelContext } from "../../contexts/ModelContext";
const Container = styled.svg`
  cursor: pointer;
  &:hover {
    fill: #1570ef;
    path {
      fill: #fff;
    }
  }
`;

function BellSlashRegular({ rowId, code }) {
  const queryClint = useQueryClient();
  const [token, setToken] = useState("");
  const [doctor, setDoctor] = useState("");
  const [name, setName] = useState("");
  const [Case, setCase] = useState("");
  const {
    setOpenAskSaveModel,
    changeData,
    openSecondModel,
    setOpenSecondModel,
    openSecondModelName,
    setOpenSecondModelName,
  } = useContext(ModelContext);

  const handleOpen = () => {
    setOpenSecondModelName("BellSlashRegular");
    setCase(code);
    if (changeData) {
      setOpenAskSaveModel(true);
    } else {
      setOpenSecondModel(true);
    }
  };
  const open = () => {
    return openSecondModel && openSecondModelName === "BellSlashRegular" &&  Case == code;
  };
  const handleClose = () => setOpenSecondModel(false);
  //console.log(doctor);

  useEffect(() => {
    setToken(JSON.parse(localStorage.getItem("auth"))?.Token);
    setName(JSON.parse(localStorage.getItem("auth"))?.Name);
  }, []);

  const getTbdDoctor = async ({ queryKey }) => {
    const [_, token] = queryKey;

    const data = {};
    const res = await apiClient.postAes(
      "api/referral/GetTbcDoctor/Security",
      data
    );
    return res?.data?.Data;
  };

  const getNeurology = async ({ queryKey }) => {
    const [_, token] = queryKey;
    const data = {};

    const res = await apiClient.postAes(
      "api/referral/GetNeurology/Security",
      data
    );
    return res?.data?.Data;
  };

  const sendDoctorData = async ({ rowId, code, doctor, token }) => {
    //console.log(doctor);
    //console.log(dataAll);
    const index = dataAll.findIndex((item) => item.value === doctor);
    const doctorCode = dataAll[index].code;
    //console.log(doctorCode);
    const data = {
      Data: {
        RowId: rowId,
        Code: code,
        Value: 1,
        Content: `${doctorCode}`,
      },
    };

    const res = await apiClient.postAes(
      "api/referral/SetCaseStatus/Security",
      data
    );

    return res?.data?.Code;
  };

  const { data: TbdDoctorData } = useQuery(
    ["getTbdDoctor", token],
    getTbdDoctor,
    {
      enabled: !!token,
      refetchOnWindowFocus: false,
    }
  );
  //console.log(TbdDoctorData);

  const { data: NeurologyData } = useQuery(
    ["getNeurology", token],
    getNeurology,
    {
      enabled: !!token,
      refetchOnWindowFocus: false,
    }
  );
  // console.log(NeurologyData);

  const {
    data: sendData,
    mutate,
    isLoading,
  } = useMutation(sendDoctorData, {
    onSuccess() {
      alert("更新成功");
      //queryClint.invalidateQueries("getListData");
      window.location.reload(true);
    },
  });
  const onDuty = TbdDoctorData?.filter((v) => {
    return v.IsDefault === true;
  });
  const duty = onDuty && onDuty[0]?.Name;

  useEffect(() => {
    const dutyKey = onDuty && onDuty[0]?.Key;
    setDoctor(dutyKey);
  }, [duty]);

  //console.log(sendData);
  const data1 = TbdDoctorData?.map((v, i) => ({ ...v, role: "取栓醫師" }))?.map(
    (item) => ({
      label: item.Name,
      value: item.Key,
      code: item.Code,
      role: item.role,
    })
  );
  //console.log(data1);
  const Data2 = NeurologyData?.map((v, i) => ({ ...v, role: "神內醫師" }))?.map(
    (item) => ({
      label: item.Name,
      value: item.Key,
      code: item.Code,
      role: item.role,
    })
  );
  const dataAll = data1?.concat(Data2);
  //console.log(dataAll);

  return (
    <>
      <span style={{ padding: "5px" }} onClick={handleOpen}>
        <Container
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="0.5"
            y="0.5"
            width="23"
            height="23"
            rx="2.5"
            stroke="#057AFF"
          />
          <path
            d="M6.78823 7.10969C6.57698 6.93352 6.27027 6.97434 6.10371 7.19777C5.93715 7.42121 5.97574 7.74561 6.18699 7.92178L18.2118 17.8903C18.423 18.0665 18.7297 18.0257 18.8963 17.8022C19.0629 17.5788 19.0243 17.2544 18.813 17.0782L17.0357 15.6044C17.0459 15.5679 17.0499 15.5292 17.0499 15.4884C17.0499 14.8955 16.8265 14.3261 16.4304 13.905L16.3999 13.875C15.9835 13.4345 15.7499 12.8373 15.7499 12.2143V11.4688C15.7499 9.80592 14.6328 8.41806 13.15 8.1001V7.68761C13.15 7.30734 12.8595 7.00012 12.5 7.00012C12.1405 7.00012 11.85 7.30734 11.85 7.68761V8.1001C10.9847 8.28486 10.2454 8.83485 9.77817 9.58893L6.78823 7.10969ZM9.25006 12.2143C9.25006 12.8373 9.01647 13.4345 8.60007 13.875L8.5696 13.9072C8.17351 14.3261 7.95008 14.8955 7.95008 15.4906C7.95008 15.7376 8.13898 15.9374 8.37257 15.9374H14.2509L9.25006 11.7717V12.2164V12.2143ZM13.8 16.6249H12.5H11.2C11.2 16.9901 11.3361 17.3403 11.5799 17.5981C11.8236 17.8559 12.1547 17.9999 12.5 17.9999C12.8453 17.9999 13.1764 17.8559 13.4201 17.5981C13.6639 17.3403 13.8 16.9901 13.8 16.6249Z"
            fill="#057AFF"
          />
        </Container>
      </span>
      <Modal open={open()} onClose={handleClose} backdrop="static">
        <Modal.Header closeButton={false}>
          <Modal.Title>回覆收到通知</Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            height: "200px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-around",
          }}
        >
          <div style={{ fontSize: "14px" }}>目前班表：值班醫師為{duty}醫師</div>
          <div style={{ fontSize: "14px" }}>
            已由{name}操作 確認以下所選醫師 將進行收治評估
          </div>
          <SelectPicker
            defaultValue={doctor}
            onChange={setDoctor}
            groupBy="role"
            data={dataAll || []}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={() => {
              mutate({ rowId, code, doctor, token });
            }}
            disabled={isLoading}
            appearance="primary"
          >
            {isLoading ? "資料傳送中" : "確認"}
          </Button>
          <Button onClick={handleClose} disabled={isLoading}>
            取消返回
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default BellSlashRegular;
